import { render, staticRenderFns } from "./sub-head-secondary.vue?vue&type=template&id=238acbad&scoped=true&"
import script from "./sub-head-secondary.vue?vue&type=script&lang=js&"
export * from "./sub-head-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238acbad",
  null
  
)

export default component.exports